export default __webpack_public_path__ + "static/media/times-close.bf9d76a9.svg";